import React from 'react';
import useAllClinic from './useAllClinic';


const useGetAllRTMPlan = ({ pageNumber, perpageData, searchTerm = "",clinicId}: { 
    pageNumber: number; 
    perpageData: number; 
    searchTerm?: string;
    clinicId: string; 
  }) => {
    const { AssociateClinic, getAssociateClinicData, AssociateClinicDataLoading } = useAllClinic({ 
      pageNumber, 
      perpageData, 
      searchTerm,
      clinicId 
    });
  
    React.useEffect(() => {
      getAssociateClinicData();
    }, [pageNumber, searchTerm, clinicId]);
  
    return {
      AssociateClinic,
      getAssociateClinicData,
      AssociateClinicDataLoading,
    };
  };

export default useGetAllRTMPlan;
